import script from "./App.vue?vue&type=script&setup=true&lang=ts&name=app"
export * from "./App.vue?vue&type=script&setup=true&lang=ts&name=app"

import "./App.vue?vue&type=style&index=0&id=a9faace8&lang=less"

const __exports__ = script;

export default __exports__